import React from 'react';
import ProductPage from '../product_page/productPage';

const Women = () => {
    return <ProductPage
        page_title={'Women'}
        initial_filters={{gender: 'Women'}}
        seo={{
            title: "Women's Fashion from Emerging Brands | The Sidewalk",
            description: "from Tiger Mist, Cotton On, and other emerging brands. Discover sweaters, mini skirts, dresses, and more."
        }}
    />;
};

export default Women;